import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "frame", "state", "loading"]
  static values = { url: String }

  connect() {
    this.objectUrl = null
  }

  disconnect() {
    this.revokeObjectUrl()
  }

  async preview(event) {
    event?.preventDefault()
    if (!this.hasFormTarget) return

    const rawFormData = new FormData(this.formTarget)
    const formData = new FormData()
    for (const [key, value] of rawFormData.entries()) {
      if (key === "_method") continue
      formData.append(key, value)
    }
    this.setState("Generating preview...")
    this.setLoading(true)
    try {
      const response = await fetch(this.previewUrl(), {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/pdf",
          "X-CSRF-Token": this.csrfToken(),
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "same-origin",
      })

      if (!response.ok) {
        const message = await response.text()
        this.setState(message || "Preview failed", true)
        this.setLoading(false)
        return
      }

      const blob = await response.blob()
      this.revokeObjectUrl()
      this.objectUrl = URL.createObjectURL(blob)

      if (this.hasFrameTarget) {
        this.frameTarget.src = this.objectUrl
        this.frameTarget.hidden = false
      }

      this.setLoading(false)
      this.setState("Preview updated")
    } catch (_error) {
      this.setLoading(false)
      this.setState("Preview failed", true)
    }
  }

  previewUrl() {
    return this.urlValue ||
      this.element.getAttribute("data-documents-preview-url-value") ||
      this.formTarget?.getAttribute("data-documents-preview-url-value") ||
      this.formTarget?.dataset?.documentsPreviewUrlValue ||
      this.derivedPreviewUrl() ||
      ""
  }

  derivedPreviewUrl() {
    const action = this.formTarget?.getAttribute("action")
    if (!action) return ""

    return action.replace(/\/templates(?:\/[^/]+)?(?:\/edit)?$/, "/templates/preview")
  }

  setState(message, isError = false) {
    if (!this.hasStateTarget) return
    this.stateTarget.textContent = message
    this.stateTarget.classList.toggle("fg-danger", isError)
    this.stateTarget.classList.toggle("fg-2", !isError)
  }

  setLoading(isLoading) {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.toggle("d-none", !isLoading)
    }
    if (this.hasFrameTarget && isLoading) {
      this.frameTarget.hidden = true
    }
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }

  revokeObjectUrl() {
    if (!this.objectUrl) return
    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
